export const fetchFileName = (link) => {
  let url = link.split("/");
  let filename = url[url.length - 1];
  return filename.slice(filename.indexOf("_") + 1);
};

export const createPdfDownloadName = (fileName = "") => {
  if (!fileName) {
    return "file.pdf";
  }

  return fileName.replace(/\.[^.]+$/, "") + ".pdf";
};

const triggerBlobDownload = (blob, fileName) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

export const downloadFromLink = async (link, options = {}) => {
  const {
    headers,
    fileName,
    fallbackToDirectLink = true,
  } = options;

  const resolvedFileName = fileName || fetchFileName(link) || "file.pdf";

  try {
    const response = await fetch(link, {
      mode: "cors",
      headers,
    });

    if (!response.ok) {
      const error = new Error(`Download failed with status ${response.status}`);
      error.status = response.status;
      throw error;
    }

    const blob = await response.blob();
    triggerBlobDownload(blob, resolvedFileName);
  } catch (error) {
    if (!fallbackToDirectLink) {
      throw error;
    }

    const a = document.createElement("a");
    a.href = link;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    a.download = resolvedFileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
};
